export default __webpack_public_path__ + "static/media/banner02.ba9eb596.png";